export const PoiCategories = {
  transport: "transport",
  health: "health",
  education: "education",
  outdoor: "outdoor",
  food: "food",
  shopping: "shopping",
  childcare: "childcare",
  professional: "professional",
}

export const CategoryTypes = [
  "transport",
  "health",
  "education",
  "outdoor",
  "food",
  "shopping",
  "childcare",
  "professional",
]

export const PoiDisplayNames = {
  transport: "Transport",
  health: "Hospitals",
  education: "Education",
  outdoor: "Amenities",
  food: "Food & Drink",
  shopping: "Shopping",
  childcare: "Childcare & Early Learning",
  professional: "Career Hubs",
}



// WEBPACK FOOTER //
// ./src/constants/poiCategories.js